import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

const hasStoredEntries = (key: SyncStorageKey.CART | SyncStorageKey.MINIMAL_CART): boolean => {
  const entries = syncStorage.getObject<unknown[]>(key);
  return Array.isArray(entries) && entries.length > 0;
};

/**
 * Reads persisted cart entries straight from storage (the source of truth), independent of Redux
 * hydration, experiment loading, or store/One-Menu resolution timing.
 *
 * Used to gate the cart -> menu redirect: on a hard reload the cart route can mount and evaluate the
 * empty-cart redirect before `SYNC_WITH_STORAGE` populates Redux, so an empty in-memory cart is not
 * proof the user has nothing to recover. If either cart still has entries in storage, the correct
 * cart will hydrate shortly and we must not bounce the user to the menu.
 */
export const hasStoredCartEntries = (): boolean =>
  hasStoredEntries(SyncStorageKey.CART) || hasStoredEntries(SyncStorageKey.MINIMAL_CART);
